module.exports = __webpack_public_path__ + "static/media/ken_fukuyama.1acb8b18.png";